import { render, staticRenderFns } from "./FacebookMvp.vue?vue&type=template&id=615496ca&scoped=true&"
import script from "./FacebookMvp.vue?vue&type=script&lang=js&"
export * from "./FacebookMvp.vue?vue&type=script&lang=js&"
import style0 from "./FacebookMvp.vue?vue&type=style&index=0&id=615496ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615496ca",
  null
  
)

export default component.exports